import {
  ConditionRowFilter,
  ConditionType,
  operandsList,
  OperandType
} from "@/frontend/components/FilterV2/model/types";
import { inverseTypesCompressionMap, typesCompressionMap } from "@/frontend/components/FilterV2/const/const";
import { v4 } from "uuid";
import logger from "@/frontend/shared/lib/logger/logger";

export function compressFilter(filter: ConditionRowFilter): string | null {
  if (
    !filter.operand ||
    !filter.type ||
    (filter.type === "group" && !filter.filters) ||
    (filter.type !== "group" && !filter.value)
  ) {
    logger.Warn("Filter is not valid", filter);
    return null;
  }
  let resultString = `${filter.isOr ? "OR" : "AND"}__${typesCompressionMap[filter.type]}__${
    filter.operand
  }__${encodeURIComponent(filter.value || "")}`;

  if (filter?.filters?.length) {
    const subFiltersCleaned = filter.filters.map((f) => {
      const compressed = compressFilter(f);
      if (!compressed) return null;
      return compressed;
    });
    resultString += `__(${encodeURIComponent(JSON.stringify(subFiltersCleaned))})`;
  }

  return resultString;
}

function extractSubFilters(str: string) {
  return str.substring(1, str.length - 1);
}

export function decompressFilterBySeparator(filter: string, separator: string): ConditionRowFilter | null {
  try {
    const [isOr, type, operand, value, ...filters] = decodeURIComponent(filter).split(separator);
    const flattenedFilters = filters.join(separator);
    if (operandsList.indexOf(operand) === -1) return null;
    const expandedFilter = {
      id: v4(),
      type: inverseTypesCompressionMap[type as keyof typeof inverseTypesCompressionMap] as ConditionType,
      operand: operand as OperandType,
      isOr: isOr === "OR",
      value: decodeURIComponent(value),
      filters: flattenedFilters
        ? JSON.parse(decodeURIComponent(extractSubFilters(flattenedFilters))).map((f: string) => ({
            ...decompressFilterBySeparator(f, "__")
          }))
        : null
    };
    if (!expandedFilter.type) return null;
    return expandedFilter;
  } catch (e) {
    logger.Error("Error decompressing filters", e);
    return null;
  }
}

export function decompressFilter(filter: string): ConditionRowFilter | null {
  return decompressFilterBySeparator(filter, "__");
}
